import React, { useState } from "react";
import styled from "styled-components";
import { Description, Footer, ProceedButton, Title } from "./components";
import fontisto_language from "../../assets/images/fontisto_language.svg";
import GrantPermissions from "./GrantPermissions";
import { LogoContainer, LogoIcon } from "./components/Common/Common";
import { ProgressBar } from "./components";

const LanguageList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const LanguageItem = styled.div`
  padding: 14px;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid rgb(221, 221, 221);
  color: rgb(51, 51, 51);
  background-color: white;
  transition: background-color 0.3s, color 0.3s;
  display: flex;
  -webkit-box-pack: justify;
  font-weight: 600;
  -webkit-box-align: start;
  align-items: center;
  gap: 5px;

  &:hover {
    background-color: #f0f0f0;
  }

  &.selected {
    background-color: #00b3ad;
    color: white;
  }
`;

const LanguageRadio = styled.div`
  height: 16px;
  width: 16px;
  border-radius: 50%;
  border: 1.5px solid black;
  display: flex;
  justify-content: center;
  align-items: center;

  &.selected {
    border: 1.5px solid white;
  }
`;

const LanguagePoint = styled.div`
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-color: white;
`;
const DeniedPermissionModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  max-width: 400px;
  width: 100%;
`;

const ModalButton = styled.button`
  margin-top: 20px;
  padding: 10px 20px;
  background: #20564b;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: #18483d;
  }
`;

const Text = styled.p`
  font-size: larger;
  line-height: 33px;
`;

const PermissionList = styled.ul`
  margin: 15px 0;
  padding-left: 20px;
  color: #333;
  line-height: 1.5;
`;

const PermissionItem = styled.li`
  margin-bottom: 10px;
  font-size: larger;
  text-align: left;
  strong {
    font-weight: bold;
  }
`;

// const ProgressBar = styled.div`
//   width: 100%;
//   height: 4px;
//   background-color: #e0e0e0;
//   margin: 8px 0;

//   &::after {
//     content: "";
//     display: block;
//     width: 10%;
//     height: 100%;
//     background-color: #20564b;
//   }
// `;
const SkipButton = styled.button`
  background: transparent;
  border: none;
  color: #2f313b;
  font-size: 16px;
  font-weight: 600;
  width: 30%;
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;

  &:hover {
    opacity: 0.8;
  }

  span {
    font-size: 12px;
    font-weight: 400;
    color: #6c757d;
  }
`;

const BottomButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: auto;
  margin-bottom: 20px;
  gap: 16px; /* Ensures 16px gap */
  box-sizing: border-box;
`;

const NextButton = styled.button`
  background: rgb(51, 51, 51);
  color: white;
  border: none;
  padding: 10px 50px;
  border-radius: 6px;
  width: 50%;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
`;

const MainContainer = styled.div`
  padding: 0px 16px;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const Content = styled.main<{ type?: string }>`
  flex: 1;
  align-items: left;
  flex-direction: column;
  display: ${(props) => props.type === "center" && "flex"};
`;

const LanguagePreference = ({
  handlePermission,
  skipLocation,
  handleLanguageChange,
}) => {
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const languages = ["English", "हिन्दी", "বাংলা", "ગુજરાતી", "اردو"];
  const [openPermissionModal, SetOpenPermissionModal] = useState(false);
  const [deniedPermissionModal, setDeniedPermissionModal] = useState(false);
  const [cameraAndMicPermission, setCameraAndMicPermission] = useState(false);
  const [locationPermission, setLocationPermission] = useState(false);

  const onDeniedPermission = () => {
    setDeniedPermissionModal(true);
    SetOpenPermissionModal(false);
  };
  const onClosePermission = () => {
    if (!locationPermission && cameraAndMicPermission) {
      skipLocation();
    }
    setDeniedPermissionModal(false);
  };

  return (
    <>
      <MainContainer>
        <ProgressBar currentStep={1} totalSteps={7} type="dark" />

        <Content type="center">
          <LogoContainer>
            <LogoIcon src={fontisto_language} />
          </LogoContainer>
          <Title>Select your preferred language for a better experience</Title>
          <LanguageList>
            {languages.map((language, index) => (
              <LanguageItem
                key={index}
                className={selectedLanguage === language ? "selected" : ""}
                onClick={() => {
                  setSelectedLanguage(language);
                  handleLanguageChange(language);
                }}
              >
                <LanguageRadio
                  className={selectedLanguage === language ? "selected" : ""}
                >
                  {selectedLanguage === language && <LanguagePoint />}
                </LanguageRadio>
                {language}
              </LanguageItem>
            ))}
          </LanguageList>
          <BottomButtons className="flex w-full justify-end">
            {/* <SkipButton  onClick={() => SetOpenPermissionModal(true)}>
              Skip
              <span>For demo use</span>
            </SkipButton> */}
            <NextButton onClick={() => SetOpenPermissionModal(true)}>
              Next
            </NextButton>
          </BottomButtons>
        </Content>
      </MainContainer>
      <GrantPermissions
        isOpen={openPermissionModal}
        onClose={() => SetOpenPermissionModal(false)}
        onPermission={handlePermission}
        onDeniedPermission={onDeniedPermission}
        setCameraAndMicPermission={setCameraAndMicPermission}
        setLocationPermission={setLocationPermission}
      />
      {deniedPermissionModal && (
        <DeniedPermissionModal>
          <ModalContent>
            <PermissionList>
              {!cameraAndMicPermission && (
                <PermissionItem>
                  Please allow <strong>camera</strong> and <strong>mic</strong>{" "}
                  permissions.
                </PermissionItem>
              )}
              {!locationPermission && (
                <PermissionItem>
                  Please allow <strong>location</strong> permission.
                </PermissionItem>
              )}
            </PermissionList>
            <Text>Please give the permissions and try again.</Text>
            <ModalButton onClick={onClosePermission}>
              {!locationPermission && cameraAndMicPermission ? "Skip" : "Close"}
            </ModalButton>
          </ModalContent>
        </DeniedPermissionModal>
      )}
    </>
  );
};

export default LanguagePreference;
